import React, { useState } from "react";
import leftPng from "../../../../content/images/left.png";
import * as omnimap from "../../../../api/omnimap/omnimapActions";
import CatalogusGebruikers from "./modals/CatalogusGebruikers";
import Attachments from "./modals/Attachments";
import $ from "jquery";

const Detail = () => {
  return (
    <div id="detailSide" className="d-none">
      <div className="detail-title">Planningspatroon in detail</div>
      <div className="clearfix">
        <div className="float-left mt-4">
          <a id="detail-button" className="back-page-link" role="button">
            <img src={leftPng} width={9} height={12} /> &nbsp;Terug naar
            Planningspatroon
          </a>
        </div>
        <div className="float-right mt-0">
          <a id="edit-button" className="button bewerken">
            Bewerken
          </a>
        </div>
      </div>
      <div className="row clearfix">
        <div className="col-lg-4 text-center">
          <div className="box-detail-active">
            <div className="box-title-1-active">Naam</div>
            <div className="box-title-2-active" id="d-algemeen-naam" />
            <span
              className="tooltiptext detail"
              id="naam-tooltip"
              id="d-algemeen-naam-tooltip"
            ></span>
          </div>
        </div>
        <div className="col-lg-4 text-center">
          <div className="box-detail">
            <div className="box-title-1">Code</div>
            <div className="box-title-2" id="d-algemeen-code" />
          </div>
        </div>
        <div className="col-lg-4 text-center">
          <div className="box-detail">
            <div className="box-title-1">Omschrijving</div>
            <div className="box-title-2" id="d-algemeen-omschrijving" />
            <span
              className="tooltiptext detail"
              id="naam-tooltip"
              id="d-algemeen-omschrijving-tooltip"
            ></span>
          </div>
        </div>
      </div>
      <div className="row clearfix">
        <div className="col-lg-4 text-center">
          <div className="box-detail">
            <div className="box-title-1">Frequentie</div>
            <div className="box-title-2" id="d-algemeen-frequentie" />
          </div>
        </div>
        <div className="col-lg-4 text-center">
          <div className="box-detail">
            <div className="box-title-1">Starten Na</div>
            <div className="box-title-2" id="d-algemeen-starten" />
          </div>
        </div>
        <div className="col-lg-4 text-center">
          <div className="box-detail">
            <div className="box-title-1">Max Aantal</div>
            <div className="box-title-2" id="d-algemeen-aantal" />
          </div>
        </div>
      </div>
      <div className="row clearfix">
        <div className="col-lg-4 text-center">
          <div className="box-detail">
            <div className="box-title-1">Cyclus</div>
            <div className="box-title-2" id="d-algemeen-cyclus" />
          </div>
        </div>
        <div className="col-lg-4 text-center">
          <div className="box-detail">
            <div className="box-title-1">Actief</div>
            <label className="switch">
              <input id="algemeen_active" type="checkbox" disabled />
              <span className="slider-checkbox round" />
            </label>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Detail;
